// Copyright (c) StrangeBee 2023

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listTag' }, { name: 'freetags' }],
    extraData: ['usage'],
    name: 'get-all-custom-tags',
    sort: ['+predicate'],
});
